import * as React from "react";
import IconButton from "@mui/material/IconButton";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";

export default function AllMessageDrawer() {
  const [isRightSidebarVisible, setIsRightSidebarVisible] = React.useState(true);

  const toggleRightSidebar = () => {
    setIsRightSidebarVisible(!isRightSidebarVisible);
    
    // Toggle visibility of the existing right sidebar
    const peopleBox = document.querySelector('.peopleBox') as HTMLElement;
    if (peopleBox) {
      peopleBox.style.display = isRightSidebarVisible ? 'none' : 'block';
    }
  };

  return (
    <div className="addedSkillerSidebar">
      <IconButton 
        onClick={toggleRightSidebar}
        style={{
          backgroundColor: "#3380FF",
          color: "white",
          width: "40px",
          height: "40px",
          borderRadius: "0",
          boxShadow: "0 2px 8px rgba(50, 127, 255, 0.3)",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#3974d4';
          e.currentTarget.style.transform = 'scale(1.05)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#3380FF';
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        <QuestionAnswerIcon style={{ fontSize: "1.2rem" }} />
      </IconButton>
    </div>
  );
}
